/*
  Monoline SVG icons — 1.6px stroke, currentColor.
  Use as: <Icon name="check" />  or  <Icon name="arrow-right" size={20} />
*/
import React from "react";

const paths = {
  check: <polyline points="4 12 10 18 20 6" />,
  "arrow-right": (
    <>
      <line x1="4" y1="12" x2="20" y2="12" />
      <polyline points="14 6 20 12 14 18" />
    </>
  ),
  "arrow-up-right": (
    <>
      <line x1="7" y1="17" x2="17" y2="7" />
      <polyline points="8 7 17 7 17 16" />
    </>
  ),
  menu: (
    <>
      <line x1="4" y1="7" x2="20" y2="7" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="17" x2="20" y2="17" />
    </>
  ),
  close: (
    <>
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </>
  ),
  whatsapp: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      stroke="none"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.1-.471-.15-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"
    />
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <polyline points="3 7 12 13 21 7" />
    </>
  ),
  phone: <path d="M4 5c0 8 7 15 15 15l2-3-4-2-2 2a10 10 0 0 1-5-5l2-2-2-4Z" />,
  mapPin: (
    <>
      <path d="M12 21s7-7 7-12a7 7 0 1 0-14 0c0 5 7 12 7 12Z" />
      <circle cx="12" cy="9" r="2.5" />
    </>
  ),
  factory: (
    <>
      <path d="M3 21V10l6 4V10l6 4V6l6 4v11Z" />
      <line x1="7" y1="21" x2="7" y2="17" />
      <line x1="11" y1="21" x2="11" y2="17" />
      <line x1="15" y1="21" x2="15" y2="17" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18Z" />
    </>
  ),
  shield: <path d="M12 3 4 6v6c0 5 4 8 8 9 4-1 8-4 8-9V6l-8-3Z" />,
  truck: (
    <>
      <rect x="2" y="7" width="12" height="10" rx="1" />
      <path d="M14 10h4l3 3v4h-7Z" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  award: (
    <>
      <circle cx="12" cy="10" r="6" />
      <path d="m8 14-2 7 6-3 6 3-2-7" />
    </>
  ),
  layers: (
    <>
      <polygon points="12 3 22 8 12 13 2 8 12 3" />
      <polyline points="2 13 12 18 22 13" />
    </>
  ),
  scissors: (
    <>
      <circle cx="6" cy="6" r="2" />
      <circle cx="6" cy="18" r="2" />
      <path d="M8 6 20 18M8 18 20 6" />
    </>
  ),
  package: (
    <>
      <path d="M3 8v11l9 3 9-3V8l-9-3-9 3Z" />
      <path d="M3 8 12 11 21 8" />
      <path d="M12 11v11" />
    </>
  ),
  droplet: <path d="M12 3s6 7 6 12a6 6 0 0 1-12 0c0-5 6-12 6-12Z" />,
  flame: <path d="M12 21c-4 0-6-3-6-6 0-4 3-5 3-9 3 2 3 5 3 5s2-2 2-4c3 2 4 5 4 8s-2 6-6 6Z" />,
  hospital: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="1" />
      <path d="M12 8v8M8 12h8" />
    </>
  ),
  hotel: (
    <>
      <rect x="3" y="9" width="18" height="12" rx="1" />
      <path d="M3 9V5h18v4" />
      <path d="M8 21v-4M16 21v-4" />
    </>
  ),
  dumbbell: (
    <>
      <path d="M4 9v6M20 9v6M2 12h4M18 12h4" />
      <rect x="7" y="8" width="10" height="8" rx="1" />
    </>
  ),
  spa: (
    <>
      <path d="M12 3c-3 4-3 8 0 12 3-4 3-8 0-12Z" />
      <path d="M5 12c4-3 8-3 12 0-4 3-8 3-12 0Z" />
    </>
  ),
  store: (
    <>
      <path d="M3 9V7l2-3h14l2 3v2" />
      <path d="M3 9v11h18V9" />
      <path d="M3 9c0 1.5 1 2.5 2.5 2.5S8 10.5 8 9M8 9c0 1.5 1 2.5 2.5 2.5S13 10.5 13 9M13 9c0 1.5 1 2.5 2.5 2.5S18 10.5 18 9M18 9c0 1.5 1 2.5 2.5 2.5S23 10.5 23 9" />
    </>
  ),
  gift: (
    <>
      <rect x="3" y="9" width="18" height="12" rx="1" />
      <path d="M3 13h18" />
      <path d="M12 9v12" />
      <path d="M12 9s-2-6-5-6a2 2 0 0 0 0 6h5ZM12 9s2-6 5-6a2 2 0 0 1 0 6h-5Z" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="9" r="3" />
      <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
      <circle cx="17" cy="8" r="2.5" />
      <path d="M15 15c3 0 6 2 6 5" />
    </>
  ),
  clipboard: (
    <>
      <rect x="6" y="5" width="12" height="16" rx="1" />
      <path d="M9 5V3h6v2" />
      <line x1="9" y1="11" x2="15" y2="11" />
      <line x1="9" y1="15" x2="13" y2="15" />
    </>
  ),
  // Product feature badges (screenshot 231056)
  "feat-extra-long": (
    <>
      <rect x="4" y="9" width="16" height="6" rx="1" />
      <polyline points="7 6 4 9 7 12" />
      <polyline points="17 6 20 9 17 12" />
    </>
  ),
  "feat-safe": (
    <>
      <path d="M12 3 4 6v6c0 5 4 8 8 9 4-1 8-4 8-9V6l-8-3Z" />
      <polyline points="9 12 11 14 15 10" />
    </>
  ),
  "feat-cotton": (
    <>
      <circle cx="12" cy="12" r="3.5" />
      <circle cx="7" cy="9" r="2.8" />
      <circle cx="17" cy="9" r="2.8" />
      <circle cx="8" cy="16" r="2.8" />
      <circle cx="16" cy="16" r="2.8" />
    </>
  ),
  "feat-absorb": (
    <>
      <path d="M6 15h12M5 18h14M7 12h10" />
      <path d="M9 9c1-2 2-3 3-5 1 2 2 3 3 5" />
    </>
  ),
  "feat-odour": (
    <>
      <path d="M6 6c2 2 2 4 0 6s-2 4 0 6" />
      <path d="M12 6c2 2 2 4 0 6s-2 4 0 6" />
      <path d="M18 6c2 2 2 4 0 6s-2 4 0 6" />
    </>
  ),
  "feat-soft": (
    <>
      <path d="M12 3c3 4 6 5 6 10a6 6 0 0 1-12 0c0-5 3-6 6-10Z" />
      <path d="M12 8v13" />
    </>
  ),
  "eye": (
  <>
    {/* Outer eye shape */}
    <path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6Z" />
    {/* Iris */}
    <circle cx="12" cy="12" r="3" />
    {/* Pupil */}
    <circle
      cx="12"
      cy="12"
      r="1.2"
      fill="currentColor"
      stroke="none"
    />
  </>
),

"target": (
  <>
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="5" />
    <circle
      cx="12"
      cy="12"
      r="1.5"
      fill="currentColor"
      stroke="none"
    />
    <line x1="12" y1="2" x2="12" y2="5" />
    <line x1="12" y1="19" x2="12" y2="22" />
    <line x1="2" y1="12" x2="5" y2="12" />
    <line x1="19" y1="12" x2="22" y2="12" />
  </>
),
};

export default function Icon({ name, size = 22, className = "", strokeWidth = 1.6, ...rest }) {
  const p = paths[name];
  if (!p) return null;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {p}
    </svg>
    
  );
}
